import { Paper, Typography, Box } from '@mui/material';
import { ResponsiveContainer, PieChart, Pie, Cell, Tooltip } from 'recharts';
import { APPLICATION_STATUS_COLORS } from '../../../../constants/statusColors';

interface Props {
  data: { name: string; value: number }[];
  total: number;
}

const StatusDistributionChart = ({ data, total }: Props) => (
  <Paper elevation={0} sx={{
    p: { xs: 2, md: 3 }, borderRadius: 3,
    border: '1px solid #e5e7eb', height: '100%',
    display: 'flex', flexDirection: 'column',
  }}>
    <Typography fontWeight={700} sx={{ fontSize: '0.95rem', color: '#0f172a', mb: 0.5 }}>
      상태 분포
    </Typography>
    <Typography variant="caption" color="text.secondary" sx={{ mb: 1, display: 'block' }}>
      전체 신청 건의 상태별 비율
    </Typography>
    <Box sx={{ flex: 1, position: 'relative', minHeight: 180 }}>
      {data.length === 0 ? (
        <Box display="flex" alignItems="center" justifyContent="center" height="100%">
          <Typography color="text.secondary" fontSize="0.85rem">데이터가 없습니다</Typography>
        </Box>
      ) : (
        <>
          <ResponsiveContainer>
            <PieChart>
              <Pie
                data={data}
                cx="50%" cy="50%"
                innerRadius={50} outerRadius={80}
                dataKey="value"
                stroke="#fff"
                strokeWidth={2}
                labelLine={false}
              >
                {data.map((entry) => (
                  <Cell key={entry.name} fill={APPLICATION_STATUS_COLORS[entry.name] || '#94a3b8'} />
                ))}
              </Pie>
              <Tooltip
                contentStyle={{
                  borderRadius: 10, border: '1px solid #e5e7eb',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.08)', fontSize: '0.85rem',
                }}
                formatter={(value: number, name: string) => [`${value}건 (${total > 0 ? Math.round((value / total) * 100) : 0}%)`, name]}
              />
            </PieChart>
          </ResponsiveContainer>
          {/* 중앙 총 건수 */}
          <Box sx={{
            position: 'absolute', top: '50%', left: '50%',
            transform: 'translate(-50%, -50%)',
            textAlign: 'center', pointerEvents: 'none',
          }}>
            <Typography sx={{ fontSize: '1.2rem', fontWeight: 800, color: '#0f172a', lineHeight: 1.2 }}>
              {total}
            </Typography>
            <Typography sx={{ fontSize: '0.6rem', color: '#94a3b8', fontWeight: 600 }}>
              총 건수
            </Typography>
          </Box>
        </>
      )}
    </Box>

    {/* 하단 범례 (건수 포함) */}
    <Box sx={{
      display: 'flex', flexWrap: 'wrap', gap: 0.6, mt: 1, pt: 1.5, borderTop: '1px solid #f0f0f0',
    }}>
      {data.map((entry) => (
        <Box key={entry.name} display="flex" alignItems="center" gap={0.3}
          sx={{ bgcolor: '#f8fafc', borderRadius: 1, px: 0.8, py: 0.3 }}
        >
          <Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: APPLICATION_STATUS_COLORS[entry.name] || '#94a3b8' }} />
          <Typography sx={{ fontSize: '0.65rem', color: '#334155', fontWeight: 600 }}>
            {entry.name}
          </Typography>
          <Typography sx={{ fontSize: '0.65rem', color: '#94a3b8', fontWeight: 700 }}>
            {entry.value}
          </Typography>
        </Box>
      ))}
    </Box>
  </Paper>
);

export default StatusDistributionChart;
